/** Число, длительность и срок годности в формах трёх языков. */

function duration(minutes: number, hour: string, minute = 'min'): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m} ${minute}`;
  return m === 0 ? `${h} ${hour}` : `${h} ${hour} ${m} ${minute}`;
}

/** «3 h», «1 h 30 min», «45 min»: на сколько продлён срок доставки. */
export const durationSr = (minutes: number) => duration(minutes, 'h');
export const durationEn = (minutes: number) => duration(minutes, 'h');
export const durationRu = (minutes: number) => duration(minutes, 'ч', 'мин');

const isOne = (n: number) => n % 10 === 1 && n % 100 !== 11;
const isFew = (n: number) => n % 10 >= 2 && n % 10 <= 4 && !(n % 100 >= 12 && n % 100 <= 14);

/** Форма сербского существительного при числе: 1 artikal, 2 artikla, 5 artikala. */
export function serbianForm(n: number, one: string, few: string, many: string): string {
  return isOne(n) ? one : isFew(n) ? few : many;
}

/** Число с существительным в нужной форме: 1 товар, 2 товара, 5 товаров. */
export function russianCount(n: number, one: string, few: string, many: string): string {
  return `${n} ${isOne(n) ? one : isFew(n) ? few : many}`;
}

/** Срок годности днями, месяцами (кратно 30 от двух месяцев) или годами (кратно 360 от двух лет). */
function shelfUnit(days: number): { value: number; unit: 0 | 1 | 2 } {
  if (days >= 720 && days % 360 === 0) return { value: days / 360, unit: 2 };
  if (days >= 60 && days % 30 === 0) return { value: days / 30, unit: 1 };
  return { value: days, unit: 0 };
}

export function serbianDuration(days: number): string {
  const { value: n, unit } = shelfUnit(days);
  if (unit === 2) return `${n} ${isOne(n) ? 'godina' : isFew(n) ? 'godine' : 'godina'}`;
  if (unit === 1) return `${n} ${isOne(n) ? 'mesec' : isFew(n) ? 'meseca' : 'meseci'}`;
  return `${n} ${isOne(n) ? 'dan' : 'dana'}`;
}

export function englishDuration(days: number): string {
  const { value: n, unit } = shelfUnit(days);
  const word = unit === 2 ? 'year' : unit === 1 ? 'month' : 'day';
  return `${n} ${n === 1 ? word : `${word}s`}`;
}

export function russianDuration(days: number): string {
  const { value: n, unit } = shelfUnit(days);
  if (unit === 2) return `${n} ${isOne(n) ? 'год' : isFew(n) ? 'года' : 'лет'}`;
  if (unit === 1) return `${n} ${isOne(n) ? 'месяц' : isFew(n) ? 'месяца' : 'месяцев'}`;
  return `${n} ${isOne(n) ? 'день' : isFew(n) ? 'дня' : 'дней'}`;
}
